import { Directive, HostListener } from "@angular/core";
import { AnnotationService } from "./annotation.service";

@Directive({
  selector: "[appDraw]",
})
export class DrawDirective {
  constructor(private annotationService: AnnotationService) {}

  @HostListener("touchmove", ["$event"]) onTouchMove(event: TouchEvent) {
    this.annotationService.touchMove(event);
    event.preventDefault();
  }

  @HostListener("mousedown", ["$event"]) onMouseDown(event: MouseEvent) {
    this.annotationService.mouseDown(event);
  }

  @HostListener("click", ["$event"]) onMouseClick(event: MouseEvent) {
    this.annotationService.mouseClick(event);
  }

  @HostListener("dblclick", ["$event"]) onMouseDblClick(event: MouseEvent) {
    this.annotationService.mouseDblClick(event);
  }

  @HostListener("mouseup", ["$event"]) onMouseUp(event: MouseEvent) {
    this.annotationService.mouseUp(event);
  }
}
